"use client"

import { useAutoleadsLocale } from "../lib/locale-context"
import { isNonLocalizedPath, localizedPath } from "../lib/locale-path"
import Link from "next/link"
import type { ComponentProps } from "react"

type LocaleLinkProps = Omit<ComponentProps<typeof Link>, "href"> & {
  /** English path, e.g. "/blog". Anchors and absolute URLs pass through. */
  href: string
}

/**
 * Internal link that stays inside the current language. Without it a French
 * page links to English URLs, which drops the visitor out of /fr and splits
 * the crawlable French cluster. External URLs, hash-only links and the areas
 * that exist at a single URL (login, logged-in, book, sample) pass through.
 */
export function LocaleLink({ href, ...props }: LocaleLinkProps) {
  const locale = useAutoleadsLocale()
  const shouldLocalize = href.startsWith("/") && !isNonLocalizedPath(href)
  return (
    <Link
      href={shouldLocalize ? localizedPath(href, locale) : href}
      {...props}
    />
  )
}
